const trans = translations.redirectToClubSite;
const common = translations.common;

class AFRedirectToClubSiteModal {
    constructor(afNumber) {
        this.afNumber = afNumber;
        this.club = app.getClubByAfNumber(afNumber);
        this.selector = `#redirectMessageModal-${afNumber}`;
        this.initialized = false;
    }

    show() {
        jQuery('body').append(this.template);

        this.timer = new Timer(
            this.doRedirect.bind(this),
            parseInt(app.option('map.international_redirect_popup_timeout', 5)) * 1000,
            ms => {
                const seconds = Math.floor((ms/1000) % 60);
                const redirectMessage = trans.automaticRedirectionAfter.replace('{sec}', seconds);

                this.$modal.find('[data-time-left]').html(redirectMessage);
            }
        );

        this.$modal = jQuery(this.selector);
        this.timer.start();

        this.$modal.modal();
        this.$modal.on('click', '[data-modal-button="ok"]', this.doRedirect.bind(this));
        this.$modal.on('hide.bs.modal', this.hide.bind(this));
    }

    hide() {
        this.timer.stop();
        this.$modal.hide();
        this.$modal.remove();
        //setTimeout(() => this.$modal.remove(), 10);
    }

    doRedirect() {
        if(typeof this.club !== 'undefined' && this.club.state == 'Quebec') {
            this.club.isLocalClub = false;
            this.club.url = this.club.url.replace('.com/', '.quebec/')
        } 
        if (typeof this.club !== 'undefined') {
            window.location.href = this.club.getTryUsFreeUrl();
        } else {
            // use only domain
            var url = jQuery('.infowindow-content .link-text a').first().prop('href');
            var a = document.createElement( "a" );
            a.href = url;
            window.location.href = a.origin;
        }

        this.$modal.find('[data-time-left]').hide();
        this.$modal.modal('hide');
    }

    get template() {
        const message = app.option('map.international_redirect_popup_message', '');
        let club_title;
        if (typeof this.club !== 'undefined') {
            club_title = this.club.title;
        } else {
            club_title = jQuery('.infowindow-content .link-text a').first().text();
        }
        return `<div class="modal fade modal-anytime-dialog" id="${this.selector.replace('#', '')}" tabindex="-1" role="dialog" aria-labelledby="${trans.redirectToTheClubSite}">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title">${club_title}</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="${common.close}">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>${message}</div>
            </div>
            <div class="modal-footer">
                <div data-time-left></div>
                <button type="button" class="btn btn-primary" data-modal-button="ok">
                    ${common.ok}
                </button>
                <button type="button" class="btn btn-default" data-modal-button="cancel" data-dismiss="modal">
                    ${common.cancel}
                </button>
            </div>
        </div>
    </div>
</div>`;
    }
}
